import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5e908536"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_letter_tile = _resolveComponent("letter-tile")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.word.split(''), (letter, index) => {
      return (_openBlock(), _createBlock(_component_letter_tile, {
        class: "letter-tile",
        key: `guess-list-${_ctx.guessIndex}${index}`,
        letter: letter,
        color: _ctx.color
      }, null, 8, ["letter", "color"]))
    }), 128))
  ]))
}